// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CachedContactMerge, CachedContactMergeItem } from '@/audit/api/types';
import { AuditMergedEntityLabel } from '@/audit/components/audit-merged-entity-label';

interface Props {
  property: CachedContactMerge;
}

const keyLabels: Record<keyof CachedContactMergeItem, string> = {
  comments: 'Comments',
  customerName: 'Company',
  email: 'Email',
  firstName: 'First name',
  id: 'Identifier',
  isArchived: 'Archived',
  key: 'Key',
  lastName: 'Last name',
  phone: 'Phone',
  title: 'Title',
};

export function AuditMergedContactEntityLabel(props: Props) {
  const result = props.property.newValue!; // Only new value is set for this prop

  return (
    <AuditMergedEntityLabel
      title="Merged contact:"
      result={result}
      keyLabels={keyLabels}
      pinnedKeys={['firstName', 'lastName']}
      ignoredKeys={['id', 'key']}
      emptyValueLabel="None"
    />
  );
}
